import { List, BarChart3, AlertTriangle } from 'lucide-react';

export type ViewMode = 'list' | 'report' | 'renewal';

interface TabDef {
  key: ViewMode;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

interface ViewToggleProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
  show?: boolean;
  variant?: '2tab' | '3tab';
}

const TABS_2: TabDef[] = [
  { key: 'list', label: 'List View', icon: List },
  { key: 'report', label: 'Report View', icon: BarChart3 },
];

const TABS_3: TabDef[] = [
  { key: 'list', label: 'List View', icon: List },
  { key: 'renewal', label: 'Renewal Reminder', icon: AlertTriangle },
  { key: 'report', label: 'Report View', icon: BarChart3 },
];

export default function ViewToggle({ viewMode, onChange, show = true, variant = '2tab' }: ViewToggleProps) {
  if (!show) return null;

  const tabs = variant === '3tab' ? TABS_3 : TABS_2;

  const base = 'flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors';
  const active = 'bg-blue-600 text-white';
  const inactive = 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50';

  return (
    <div className="flex items-center space-x-2">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={`${base} ${viewMode === tab.key ? active : inactive}`}
          >
            <Icon className="w-4 h-4" />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}